import * as React from 'react';
import { Create, SimpleForm, Toolbar, useNotify, useRedirect } from 'react-admin';
import { Button } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { UserRole } from '../types/types';
import useAuthorize from '../hooks/useAuthorize';
import { RecycleProductFormFields, submitRecycleProduct } from './RecycleProductFormFields';
import { useRecycleSellerContext } from './useRecycleSellerContext';

const CreateToolbarInner = ({ isSeller }: { isSeller: boolean }) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const { getValues } = useFormContext();
    const { sellerId } = useRecycleSellerContext();

    const saveListing = async (statusAction?: string, adminStatus?: string) => {
        try {
            const values = getValues();
            const response = await submitRecycleProduct(
                'POST',
                '/productrecycle',
                values,
                isSeller ? sellerId : null,
                isSeller
                    ? { statusAction: statusAction || 'draft' }
                    : { status: adminStatus || values.status || 'approved' }
            );
            if (!response.ok) {
                const body = await response.json().catch(() => ({}));
                throw new Error(body.error || 'Failed to create reprocessed product');
            }
            notify('resources.productrecycle.notification.created', {
                type: 'info',
                messageArgs: { smart_count: 1, name: 'Reprocessed product' },
            });
            redirect('/productrecycle');
        } catch (error: any) {
            notify(error.message || 'Error creating reprocessed product', { type: 'error' });
        }
    };

    return (
        <Toolbar>
            {isSeller ? (
                <>
                    <Button variant="contained" onClick={() => saveListing('draft')}>Save Draft</Button>
                    <Button variant="contained" color="secondary" onClick={() => saveListing('submit')} sx={{ ml: 1 }}>
                        Submit for Approval
                    </Button>
                </>
            ) : (
                <Button variant="contained" onClick={() => saveListing(undefined, getValues().status || 'approved')}>
                    Save
                </Button>
            )}
            <Button color="primary" onClick={() => redirect('/productrecycle')} style={{ marginLeft: 10 }}>
                Back
            </Button>
        </Toolbar>
    );
};

export const ProductRecycleCreate = (props: any) => {
    const { isSeller, sellerId } = useRecycleSellerContext();
    useAuthorize([UserRole.Admin, UserRole.Seller]);

    return (
        <Create {...props}>
            <SimpleForm
                toolbar={<CreateToolbarInner isSeller={isSeller} />}
                defaultValues={
                    isSeller && sellerId
                        ? { seller_id: sellerId, status: 'draft' }
                        : { status: 'approved' }
                }
            >
                <RecycleProductFormFields showAdminStatus={!isSeller} />
            </SimpleForm>
        </Create>
    );
};

export default ProductRecycleCreate;
